import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ISkuDetail } from "../../../models/ISkuDetail";
import useSWR from "swr";
import { PATH_NAME } from "../../../configs/pathName";
import { generalItemFetcher } from "../../../helpers/Fetchers/fetchers";
import { AWS_URL } from "../../../configs/constants";
import { useNavigate, useParams } from "react-router-dom";
import { typo } from "../../../assets/fonts/font";
import { useCart } from "../../../context/CartContext";
import colorConfigs from "../../../configs/colorConfigs";
import CustomButton from "../../common/Button/CustomButton";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "../../common/SnackBar/snackBar";

interface IProductOptionsProps {
  skuDetails: ISkuDetail;
}

const ProductOptions = ({ skuDetails }: IProductOptionsProps) => {
  const navigate = useNavigate();
  const { data: skus } = useSWR<ISkuDetail[]>(
    PATH_NAME.API_GET_SKU_DETAILS,
    generalItemFetcher
  );

  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart({ sku: skuDetails, quantity: itemQuantity });
    toast.success("Product added!")
  };

  const { slug } = useParams();

  const [filteredSkus, setFilteredSkus] = useState<ISkuDetail[]>([]);

  const [itemQuantity, setItemQuantity] = useState(1);

  const [cartTotal, setCartTotal] = useState(0);
  const isCartEnabled = process.env.REACT_APP_ENABLE_CART === 'true';

  const handleReduceItemQuantity = () => {
    if (itemQuantity > 1) {
      setItemQuantity(itemQuantity - 1);
    }
  };

  const handleIncreaseItemQuantity = () => {
    setItemQuantity(itemQuantity + 1);
  };

  const flavourItemBorder = (sku: ISkuDetail) => {
    if (sku.sku_sku === slug) {
      return "1px solid var(--color-black)";
    }
    return "1px solid var(--color-transparent)";
  };

  const navigateToFlavour = (sku: ISkuDetail) => {
    if (sku.sku_sku === slug) {
      return;
    }
    navigate(PATH_NAME.PRODUCT_DETAILS(sku.slug));
  };

  useEffect(() => {
    const filtered = skus?.filter((sku) =>
      sku.collections.some((collection) =>
        skuDetails.collections.includes(collection)
      )
    );
    setFilteredSkus(filtered ?? []);
  }, [skuDetails.collections, skus]);

  useEffect(() => {
    if (skuDetails.price) {
      setCartTotal(skuDetails.price * itemQuantity);
    }
  }, [itemQuantity, skuDetails.price]);


  return (
    <Box
      sx={{
        padding: "1rem",
        border: "1px solid var(--color-black)",
        borderRadius: "1rem",
        backgroundColor: "var(--color-white)",
      }}
    >
      <Typography sx={{ ...typo.title }}>Choose your flavour</Typography>
      <Grid
        container
        direction="row"
        spacing={2}
        sx={{ width: "100%", paddingY: "1rem", flexWrap: "wrap" }}
      >
        {/* {flavourData.map((flavour, index) => ( */}
        {filteredSkus.map((sku, index) => (
          <Grid item xs={6} sm={4} md={2}>
            <Stack
              direction="column"
              spacing={1}
              sx={{
                width: "100%",
                height: "100%",
                alignItems: "center",
                textAlign: "center",
                cursor: "pointer",
                border: flavourItemBorder(sku),
                borderRadius: "1rem",
                padding: "0.5rem",
                transition: "all 0.3s ease",
                ...typo.bodyContent,
              }}
              key={index}
              onClick={() => navigateToFlavour(sku)}
            >
              <img
                src={`${AWS_URL}/${sku.image_url}`}
                alt={sku.name}
                style={{ width: "6rem", height: "6rem", objectFit: "contain" }}
                />
              <Typography sx={{ ...typo.bodyContent }}>{sku.name}</Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
      {/* <Stack direction="column" spacing={1}>
        <Typography variant="h6">Any add-ons</Typography>
        <Stack
          direction="row"
          spacing={2}
          sx={{ width: "100%", height: "100%", paddingY: "1rem" }}
        > */}
      {/* {flavourData.map((flavour, index) => (
            <Stack
              direction="column"
              spacing={1}
              sx={{
                width: "max-content",
                height: "max-content",
                alignItems: "center",
              }}
              key={index}
            >
              <img
                src={flavour.url}
                alt={flavour.name}
                style={{ width: "5rem", height: "5rem", objectFit: "contain" }}
              />
              <Typography variant="body2">Drink</Typography>
              <CustomButton buttonType="primary">+ $2.00</CustomButton>
            </Stack>
          ))} */}
      {/* </Stack>
      </Stack> */}
      {isCartEnabled && (
        <>
          <Stack direction="row" spacing={2}>
            <Typography sx={{ ...typo.title }}>Price:</Typography>
            <Typography
              sx={{
                textDecoration: "underline",
                ...typo.title,
              }}
            >
              $ {cartTotal.toFixed(2)}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            sx={{ paddingTop: "1rem", alignItems: "center" }}
          >
            <Button
              variant="text"
              sx={{
                borderRadius: "5rem",
                border: "2px solid var(--color-black)",
                color: colorConfigs.secondary,
                width: "2rem",
                height: "2rem",
                minWidth: "2rem",
                padding: 0,
              }}
              onClick={handleReduceItemQuantity}
            >
              <Typography sx={{ ...typo.bodyContent }}>
                <RemoveIcon sx={{ fontSize: "1.2rem" }} />
              </Typography>
            </Button>
            <Typography sx={{ ...typo.bodyContent, px: 1 }}>
              {itemQuantity}
            </Typography>
            <Button
              variant="text"
              sx={{
                borderRadius: "5rem",
                border: "2px solid var(--color-black)",
                color: colorConfigs.tertiary,
                width: "2rem",
                height: "2rem",
                minWidth: "2rem",
                padding: 0,
              }}
              onClick={handleIncreaseItemQuantity}
            >
              <AddIcon sx={{ fontSize: "1.2rem" }} />
            </Button>
            <CustomButton buttonType="primary" onClick={handleAddToCart}>
              Add to Cart
            </CustomButton>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default ProductOptions;
